import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-job-pointe-action-button',
  templateUrl: './job-pointe-action-button.component.html',
  styleUrls: ['./job-pointe-action-button.component.scss'],
})
export class JobPointeActionButtonComponent implements OnInit {
  constructor() {}

  @Input() action: any;
  @Input() row: any;
  @Output() submitAction = new EventEmitter<string>();
  typeof: any = x => typeof x;

  ngOnInit(): void {}

  triggerAction(actionId: string): void {
    this.submitAction.emit(actionId);
  }
}
